import { FC } from "react";
import { AppThemeFontProperty } from "../Types";
import FontPropertyCard from "../Cards/FontPropertyCard";
import { Grid } from "@material-ui/core";

type FontPropertiesListProps = {
  propertiesList: AppThemeFontProperty[];
};

const FontPropertiesList: FC<FontPropertiesListProps> = ({ propertiesList }) => {
  const sortedProps = [...propertiesList].sort((a, b) =>
    a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  );

  return (
    <>
      <Grid container spacing={2} sx={{ padding: '1%' }}>
        {sortedProps.map((property) => (
          <Grid item xs={12} sm={12} md={6} lg={6} xl={4} key={property.themeFontPropertyKey}>
            <FontPropertyCard property={property} key={property.themeFontPropertyKey} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default FontPropertiesList;